<script setup lang="ts">
// import Isotope from "isotope-layout";
import imagesLoaded from "imagesloaded";

const props = defineProps<{
  artworks: Artwork[];
  categories?: ArtworkCategory[];
}>();

// const { data: artworks } = useFetch<Artwork[]>("/api/artworks");
// const { data: categories } = await useFetch<ArtworkCategory[]>("/api/artwork-categories");
const grid = useTemplateRef<HTMLElement>("grid");
const isotope = ref<Isotope>();

const onFilterClick = (e: Event) => {
  e.preventDefault();

  const filterValue = (e.target as HTMLAnchorElement).getAttribute("data-filter");
  isotope.value?.arrange({ filter: filterValue! });

  document.querySelectorAll(".portfolio-filter li").forEach((item) => {
    item.classList.remove("active");
  });
  (e.target as HTMLElement).parentElement?.classList.add("active");

  // Aggiorna classe active
};
const setupFilters = () => {
  if (import.meta.client) {
    document.querySelectorAll(".portfolio-filter a").forEach((link) => {
      link.addEventListener("click", (e: Event) => {
        e.preventDefault();

        const filterValue = (e.target as HTMLAnchorElement).getAttribute("data-filter");
        isotope.value?.arrange({ filter: filterValue! });

        // Aggiorna classe active
        document.querySelectorAll(".portfolio-filter li").forEach((item) => {
          item.classList.remove("active");
        });
        (e.target as HTMLElement).parentElement?.classList.add("active");
      });
    });
  }
};

onMounted(async () => {
  if (import.meta.client) {
    setTimeout(async () => {
      // await import("jquery");
      const Isotope = (await import("isotope-layout")).default;
      // const imagesLoaded = (await import("imagesloaded")).default;

      // @ts-ignore
      imagesLoaded(".masonry", async () => {
        /// @ts-ignore
        await nextTick();
        isotope.value = new Isotope(".masonry", {
          // main isotope options
          itemSelector: ".masonry-item",
          // set layoutMode
          layoutMode: "masonry",
          // options for cellsByRow layout mode
        });

        // setupFilters();
      });
    }, 500);
  }
});
</script>
<template>
  <!-- xboot Portfolio start -->
  <div class="xboot-standard-row dark-row">
    <!-- Portfolio content -->
    <div class="container-fluid">
      <div class="portfolio-content">
        <div class="portfolio-filter-wrap text-center" v-if="categories && categories.length > 0">
          <ul class="portfolio-filter">
            <li @click="onFilterClick" class="active"><a href="#" data-filter="*"> All</a></li>
            <li @click="onFilterClick" v-for="value in categories" :key="value.id">
              <a href="#" :data-filter="`.cat-${value.slug}`">{{ value.title }}</a>
            </li>
          </ul>
        </div>

        <div ref="grid" class="masonry portfolio portfolio-gutter portfolio-style-1 portfolio-masonry portfolio-not-full portfolio-3-column">
          <IndexArtworksGridItem v-for="artwork in artworks" :key="artwork.id" :artwork="artwork" />
        </div>

        <!-- <div class="pagination-area">
          <div class="load-more text-center">
            <a class="button lode-more" href="#"
              >view more<i class="ti-reload"></i
            ></a>
          </div>
        </div> -->
      </div>
    </div>
    <!-- portfolio content end -->
  </div>
  <!-- xboot Portfolio end -->
</template>
<style scoped>
[data-filter] {
  color: var(--title-color);
}
</style>
